import { useEffect, useState } from 'react';
import useUser from '../user/useUser';
// Service
import CustomerService from '../../services/customerService';

const useCustomers = (filters) => {
    const { branch } = useUser();
    const [loading, setLoading] = useState(true);
    const [activeRequests, setActiveRequests] = useState(0);
    const [searchResponse, setSearchResponse] = useState({
        customers: [],
        totalPage: 0,
        totalResults: 0
    });

    useEffect(() => {
        const abortController = new AbortController()
        const search = () => {
            setActiveRequests((prev) => prev + 1);
            setLoading(true);
            CustomerService
                .Search({ ...filters, operationCountry: branch.country }, { signal: abortController.signal })
                .then(res => setSearchResponse({
                    customers: res.values,
                    totalPage: res.totalPage,
                    totalResults: res.totalResults
                }))
                .finally(() => {
                    setActiveRequests((prev) => {
                        const newCount = prev - 1;
                        if (newCount === 0) {
                            setLoading(false);
                        }
                        return newCount;
                    });
                });
        }

        if(branch?.country)
        search();

        return () => abortController.abort()
    }, [filters, branch?.country])

    const replaceCustomer = (customer) => {
        setSearchResponse({
            ...searchResponse,
            customers: searchResponse.customers.map(u => ({ ...u, active: customer.id !== u.id ? u.active : !u.active }))
        })
    }

    return {
        ...searchResponse,
        loading,
        replaceCustomer
    }
}

export default useCustomers;